module.exports = __webpack_public_path__ + "img/why4.3cc04252.png";